import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { userYearSeasonEndpoints } from '../../../../constants';
import { UserYearSeasonType } from '../../schemas/user-year-season.schema';

class UserYearSeasonApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  updateUserYearSeason = async (UserYearSeason: UserYearSeasonType): Promise<void> => {
    return this.#requestInstance.patch(userYearSeasonEndpoints.userYearSeason, {
      seasonId: UserYearSeason.seasonId,
      userId: UserYearSeason.userId,
    });
  };
}

export const userYearSeasonApi = new UserYearSeasonApi(axios);
